//third-party
import { LocalDateTime } from "@js-joda/core";
import { Badge, Card               } from "react-bootstrap";

//spotsync
import { showDurationShort, showStartEndShort  } from "../Data/Date";
import { showAddressHtml    } from "../Data/Location";
import { showMoney          } from "../Data/Money";
import { Reservation } from "../Data/ApiTypes";
import { facilityImg } from "../Data/Common";

export function ReservationCard({ reservation: r }: { reservation: Reservation }) {
    const now = LocalDateTime.now();
    const isExpired = r.end.isBefore(now);
    const isActive = !isExpired && !r.start.isAfter(now);
    const isInFuture = r.start.isAfter(now);

    const f = r.facility;
    return <Card className="mb-2">
        <Card.Header className="text-start fw-bold d-flex align-items-center gap-1">
            {isActive && <Badge>In Progress</Badge>}
            {isInFuture && <Badge >Upcoming</Badge>}
            {isExpired && <Badge bg="secondary">Expired</Badge>}
            {showStartEndShort(r.start, r.end)}
        </Card.Header>
        <Card.Body className="purchase-layout gap-2">
            <div className="grid-area-a">
                <img className="facility-result-pic"
                    src={facilityImg( f.listImageId )}
                    style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
            </div>
            <div className="grid-area-b">
                <div className="fw-bold">{f.name}</div>
                {showAddressHtml( f.address )}
            </div>
            <div className="grid-area-c position-relative fs-4" style={{ justifySelf: "end" }}>
                <div className="fw-bold">
                    {showMoney( r.price )}
                </div>
                <div style={{ fontSize: "0.75em", position: "relative", top: "-5%", left: "0.05em" }}>
                    for {showDurationShort( r.duration )}
                </div>
            </div>
        </Card.Body>
    </Card>;
}